module.exports = __webpack_public_path__ + "static/media/Sanomat Grab Web-Light Italic TH.6cb427f3.woff2";